import * as actionTypes from "./actionTypes";

export const loadBusinessCategory = (data = {}) => {
  return {
    type: actionTypes.LOAD_BUSINESS_CATEGORY,
    data
  };
};

export const loadBusinessCategorySuccess = data => {
  return {
    type: actionTypes.LOAD_BUSINESS_CATEGORY_SUCCESS,
    data
  };
};

export const loadBusinessCategoryFail = () => {
  return {
    type: actionTypes.LOAD_BUSINESS_CATEGORY_FAIL
  };
};
